import React from 'react';
import PropTypes from 'prop-types';
import EditableTitle from '../common/EditableTitle';

const CheckIcon = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 5l2.2 2.2 3.8-3.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PrintIcon = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 9V4h12v5M6 18H4a1 1 0 01-1-1v-6a1 1 0 011-1h16a1 1 0 011 1v6a1 1 0 01-1 1h-2m-12 0v4h12v-4m-12 0h12"
    />
  </svg>
);

const RoleplayTopBar = ({
  conversationTitle,
  conversationId,
  onTitleUpdate,
  activePhase = 0,
  partialFill = 0,
  sessionNum = 1,
  // showProgress = true,
  conversationType,
  inDebriefMode = false,
}) => {
  const firstLabel = conversationType === 'sales' ? 'Discover' : 'Ready';
  const phases = [firstLabel, 'Engage', 'Agree', 'Lead'];

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="rp-top-bar">
      <div className="rp-wordmark">
        {onTitleUpdate ? (
          <EditableTitle
            title={conversationTitle || ''}
            conversationId={conversationId || ''}
            onUpdate={onTitleUpdate}
          />
        ) : (
          <span>{conversationTitle || 'Scarlett'}</span>
        )}
      </div>

      {inDebriefMode ? (
        <div className="rp-debrief-label">
          Practice Session {sessionNum} Debrief
        </div>
      ) : (
        <div className="rp-progress-track">
          {phases.map((phase, i) => {
            const done   = i < activePhase;
            const active = i === activePhase;

            const connectorWidth = done
              ? '100%'
              : (active && partialFill > 0)
                ? `${partialFill * 100}%`
                : '0%';

            return (
              <React.Fragment key={phase}>
                <div className="rp-phase-node">
                  <div className={`rp-phase-circle ${done ? 'done' : active ? 'active' : 'future'}`}>
                    {done   && <CheckIcon />}
                    {active && <div className="rp-phase-dot" />}
                  </div>
                  <span className={`rp-phase-label ${done ? 'done' : active ? 'active' : 'future'}`}>
                    {phase}
                  </span>
                </div>

                {i < phases.length - 1 && (
                  <div className="rp-connector">
                    <div className="rp-connector-fill" style={{ width: connectorWidth }} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}

      <div className="rp-top-bar-right">
        <button
          className="rp-download-btn"
          onClick={handlePrint}
          title="Print / save as PDF"
        >
          <PrintIcon />
        </button>
        <span className="rp-session-label">Session {sessionNum}</span>
      </div>
    </div>
  );
};

RoleplayTopBar.propTypes = {
  conversationTitle: PropTypes.string,
  conversationId: PropTypes.string,
  onTitleUpdate: PropTypes.func,
  activePhase: PropTypes.number,
  partialFill: PropTypes.number,
  sessionNum: PropTypes.number,
  showProgress: PropTypes.bool,
  conversationType: PropTypes.string,
  inDebriefMode: PropTypes.bool,
};

export default RoleplayTopBar;
